import Banner from "./Banner";
import JoinSection from "./JoinSection";
import Slider from "./Slider";
import Story from "./Story";
import PlaySection from "./PlaySection";
import BountyToken from "./BountyToken";
import PostSale from "./PostSale.jsx";
import RoadMap from "./RoadMap.jsx";
import Faq from "./Faq.jsx";
import OurTeam from "./OurTeam.jsx";

function Home() {
    return (
        <>
         <Banner/>
         <JoinSection/>
         <Slider/>
         <Story/>
         <PlaySection/>
         <BountyToken/>
         <RoadMap/>
         <PostSale/>
         <Faq/>
         <OurTeam/>
        </>
    )
}

export default Home
